import { getLogo } from '../../../../helpers/functions';

export const ImageAndName = ({
  className = '',
  logo,
  name,
  symbol,
  type,
}: {
  className?: string;
  logo: string;
  name: string;
  symbol: string;
  type: string;
}) => (
  <div className={`${className} flex items-center`}>
    <img
      className="h-5 w-5 rounded-full mr-2"
      src={getLogo(type, logo)}
      alt="strategyAsset icon"
    />
    <div className="flex flex-col truncate">
      <h4 className="font-medium text-sm uppercase truncate">{symbol}</h4>
      <span className="font-normal text-xxs text-grey-50 truncate capitalize-first">
        {name}
      </span>
    </div>
  </div>
);
